import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroySkin } from "../../../../actions/roblox/skinsActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { doHighlight } from "../../../../helpers/TextHelpers";

import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { setEditId, SkinInterface } from "../../../../store/roblox/skinsSlice";
import { ColumnsType } from "antd/es/table";
import { message, Space, Typography } from "antd";

import Table from "../../../../componets/Table";
import Meta from "./_Meta";

const { Paragraph } = Typography;

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const term            = searchParams.get('term') || '';
  const ids             = useAppSelector(state => state.roblox.skins.ids);
  const skins    = useAppSelector(state => state.roblox.skins.entities);
  const data            = ids ? ids.map(id => skins[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroySkin(id));

    if (destroySkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroySkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const columns: ColumnsType<SkinInterface> = [
    {
      key: 'skin',
      title: 'Skin',
      render: (_, skin) => {
        return <Meta skin={skin} size='medium' showStats={true} />;
      },
      width: 185,
      ellipsis: true
    },

    {
      key: 'search_text',
      title: 'Search text & Tags',
      render: (_, { search_text }) => {
        return (
          <div>
            <Paragraph ellipsis={{ rows: 2, expandable: true }}>
              {doHighlight(search_text, term)}
            </Paragraph>
          </div>
        );
      },
      width: 250
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id}) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
            <ButtonDestroy key='button-destroy' onClick={() => onClickDestroy(id)} />
          </Space>
        );
      },
      width: 150
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />
    </div>
  )
}

export default _ListTable;
